<div class="ub-tag-dropdown" >

  <div class="ub-tag-search ga-search-components">
    <div class="row g20">
      <div class="col">
        <mat-form-field appearance="outline" class="ub-form-input">
          <div matPrefix><ubi-cell-icons name="search-icon"></ubi-cell-icons></div>
          <input matInput type="text" placeholder="{{'search_tag_label' | translate}}" name="search" [(ngModel)]="searchBy" />
        </mat-form-field>
        <!-- <div class="filter-components">
        <ubi-cell-icons name="search-icon"></ubi-cell-icons>
        <input type="text" placeholder="{{'search_tag_label' | translate}}" type="text" class="search-input ga-search-input"
          name="search" [(ngModel)]="searchBy">
        </div> -->
      </div>
      @if (!isTagCreation) {
        <div class="col-auto">
          <div class="row g20 ga-search-components-add-wrap">
            <div class="col" >
              <button mat-button class="ub-button ub-button-radius ub-button-primary"
                [disabled]="(!filterTagArray?.length && topBarService?.selectedTagOnNodeStatus?.length && !isCheckBoxChecked) || (!filterTagArray?.length && !topBarService?.selectedTagOnNodeStatus?.length) || (filterTagArray?.length && !isCheckBoxChecked)">
                <ubi-cell-icons name="plus-icon" (click)="doTagFilter();"></ubi-cell-icons>
              </button>
            </div>
            @if (displayCreateTagButton && !isTagCreation) {
              <div class="col">
                <div (click)="navigateToCreateTagScreen()">
                  <button mat-button class="ub-button-radius ub-button ub-button-primary" matTooltipClass="ub-tooltip" matTooltip="{{ 'edit' | translate }}" [disabled]="(filterTagArray?.length && isCheckBoxChecked) || (!filterTagArray?.length && topBarService?.selectedTagOnNodeStatus?.length && isCheckBoxChecked) || isPowerQualityTemporalViewEnable"  matTooltipClass="ub-tooltip" matTooltip="{{ 'edit' | translate }}">
                    <ubi-cell-icons name="edit-icon"></ubi-cell-icons>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="row" class="tag-container">
  </div>
@if (tagList && tagList?.length) {
  <div class="ub-tag-list">
    @for (filter of tagList | filterTag:searchBy; track filter) {
      <div class="ub-tag-list-item">
        <div class="ub-tag">
          <mat-checkbox
            class="ub-form-checkbox"
            [checked]="filter?.selected"
            [disabled]="filter?.disabled"
            (click)="$event.stopPropagation()"
            (change)="onSelectTags($event, filter)"
            >
            <span
              class="ub-tag-name"
              [ngClass]="!filter?.disabled ? '' : ''"
              appEllipsisWithTooltip
              matTooltip
              matTooltipClass="ub-tooltip"
              >
              {{ filter.name }}
            </span>
          </mat-checkbox>
        </div>
      </div>
    }
  </div>
}
@if (tagList && !tagList?.length) {
  <div class="ub-no-data-message-tag" >
    <label class="ub-form-label">
      {{'no_tag_message' | translate}}
    </label>
  </div>
}

</div>